import detectIt from 'detect-it';

export const init = () => {

	if (detectIt.primaryInput === 'mouse') {
		$('html').addClass('no-touchevents');
	}
	else {
		$('html').addClass('touchevents');
	}

};
